import { BaseApi } from '../base-api';

import { type InvoicesResponse } from './interfaces';

export class InvoiceApi extends BaseApi {
  protected readonly prefix = 'invoices';

  fetchAll = (next_page: string | null) => this.get<InvoicesResponse>('', next_page ? { next_page } : {});
}
